import { createAction, createReducer } from '@reduxjs/toolkit'

type State = { shopId: string | null }

export function createInitialState(): State {
  return { shopId: null }
}

const SET_SHOP_ID = 'shop-id/set' as const
const CLEAR_SHOP_ID = 'shop-id/clear' as const

export const setShopId = createAction<string>(SET_SHOP_ID)
export const clearShopId = createAction(CLEAR_SHOP_ID)

export const reducer = createReducer(createInitialState(), builder => {
  builder
    .addCase(setShopId, (state, action) => {
      state.shopId = action.payload
    })
    .addCase(clearShopId, state => {
      state.shopId = null
    })
    .addDefaultCase(() => {
      return
    })
})
